import {Box, Stack, Typography} from "@mui/material"
import {MensajeDetalle} from "src/pages/messages"
import {MensajeDetalleFields} from "src/pages/messages/types"
import {EntityWithIdFields} from "src/types"

import CustomChip from 'src/@core/components/mui/chip'
import MessageReference from "../../../messages/components/desktop/MessageReference";
import {CountryAvatar} from "../../../../components/icons/CountryAvatar";


export const InfoMensajeDesktop = ({message}: { message: MensajeDetalle }) => {
  const {
    [EntityWithIdFields.Id]: idMensaje,
    [MensajeDetalleFields.NombreSistema]: nombreSistema,
    [MensajeDetalleFields.FechaCreacion]: stringFechaCreacion,
    [MensajeDetalleFields.FechaIngresoEtapa]: stringFechaIngresoEtapa,
    [MensajeDetalleFields.IdEtapaActual]: idEtapa,
    [MensajeDetalleFields.CodigoSistemaPrincipal]: codSistemaPrincipal,
    [MensajeDetalleFields.NombreSistemaPrincipal]: nombreSistemaPrincipal,
    [MensajeDetalleFields.NombreEtapaActual]: nombreEtapaActual,
    [MensajeDetalleFields.Referencia]: referencia,
    [MensajeDetalleFields.DiasEnEtapa]: diasEnEtapa
  } = message

  return (
    <Stack
      direction='row'
      spacing={2}
      flexGrow={1}
      flexShrink={1}
      minWidth={0}
      alignItems='center'
    >
      <CountryAvatar
        countryCode={codSistemaPrincipal}
        sx={{height: '40px', width: '40px'}}
      />

      <Box flex={1} minWidth={0} overflow='hidden'>
        <Typography variant='h6' sx={{ whiteSpace: 'normal', wordBreak: 'break-word', mb: 1.5, mt: 2 }}>{nombreSistema}</Typography>
        <MessageReference referencia={referencia} id={idMensaje}/>
        <Stack direction='row' display='flex' alignItems='center' spacing={2}>
          <Typography noWrap variant="body2">
            <Box component='span' fontWeight={600}>Etapa: </Box>{`${nombreEtapaActual}`}</Typography>
          <CustomChip
            size='small'
            skin='light'
            color={diasEnEtapa < 6 ? 'success' : diasEnEtapa < 20 ? 'warning' : 'error'}
            label={diasEnEtapa == 0 ? 'hoy' : `hace ${diasEnEtapa} dia${diasEnEtapa > 1 ? 's' : ''}`}
          />
        </Stack>
      </Box>
    </Stack>
  )
}
